import React, { useMemo, useState } from 'react';
import { Field, Text, Area, File, Select, RepeatList, useEmit } from './fields';

const blank = () => ({
    PersonContractor: '', PersonNationality: '', PersonFirstName: '', PersonLastName: '',
    PersonEmail: '', PersonContactNumber: '', PersonComments: '',
    PersonEmiratesID: '', PersonEmiratesIDExpiry: '', PersonEmiratesIDAttachment: '',
});

/** Emits an array of responsible-person objects. `contractors` fills the dropdown. */
const ResponsiblePerson = ({ onDataChange, contractors = [] }) => {
    const [rows, setRows] = useState([blank()]);
    const data = useMemo(() => rows, [rows]);
    useEmit(data, onDataChange);

    const contractorOptions = (contractors || []).map((c) => c.ContractorName).filter(Boolean);
    const set = (i, key, val) => setRows((prev) => prev.map((r, idx) => idx === i ? { ...r, [key]: val } : r));
    const add = () => setRows((prev) => [...prev, blank()]);
    const remove = (i) => setRows((prev) => prev.filter((_, idx) => idx !== i));
    const clear = (i) => setRows((prev) => prev.map((r, idx) => idx === i ? blank() : r));

    return (
        <div className="v3-wp-card">
            <div className="v3-wp-card-head"><h6 className="v3-wp-card-title">Responsible Person</h6></div>
            <RepeatList
                title="Responsible Person" items={rows} onAdd={add} onRemove={remove} onClear={clear}
                addLabel="Add Responsible Person"
                renderRow={(p, i) => (
                    <div className="v3-wp-grid">
                        <Field label="Contractor" required><Select value={p.PersonContractor} onChange={(v) => set(i, 'PersonContractor', v)} options={contractorOptions} placeholder="Select Contractor" /></Field>
                        <Field label="Nationality"><Text value={p.PersonNationality} onChange={(v) => set(i, 'PersonNationality', v)} placeholder="Nationality" /></Field>
                        <Field label="First Name" required><Text value={p.PersonFirstName} onChange={(v) => set(i, 'PersonFirstName', v)} /></Field>
                        <Field label="Last Name" required><Text value={p.PersonLastName} onChange={(v) => set(i, 'PersonLastName', v)} /></Field>
                        <Field label="Email"><Text type="email" value={p.PersonEmail} onChange={(v) => set(i, 'PersonEmail', v)} /></Field>
                        <Field label="Contact Number"><Text value={p.PersonContactNumber} onChange={(v) => set(i, 'PersonContactNumber', v)} /></Field>
                        <Field label="Emirates ID" required><Text value={p.PersonEmiratesID} onChange={(v) => set(i, 'PersonEmiratesID', v)} /></Field>
                        <Field label="Emirates ID Expiry" required><Text type="date" value={p.PersonEmiratesIDExpiry} onChange={(v) => set(i, 'PersonEmiratesIDExpiry', v)} /></Field>
                        <Field label="Emirates ID Attachment" full><File onChange={(f) => set(i, 'PersonEmiratesIDAttachment', f ? f.name : '')} /></Field>
                        <Field label="Comments" full><Area value={p.PersonComments} onChange={(v) => set(i, 'PersonComments', v)} rows={2} /></Field>
                    </div>
                )}
            />
        </div>
    );
};

export default ResponsiblePerson;
